<template>
  <b-card class="earnings-card">
    <div class="row">
      <div class="col">
        <b-card-title class="mb-1">
          {{title}}
        </b-card-title>
        <h4 class="mb-1 text-right">
          {{quantity}}
        </h4>
      </div>
      <div class="col-auto text-center">
        <b-avatar
          size="48"
          :variant="color"
        >
          <feather-icon
            size="34"
            :icon="icon"
          />
        </b-avatar>
      </div>
    </div>
  </b-card>
</template>
<script>
export default {
  props: {
    color: { type: String },
    quantity: { type: Number },
    title: { type: String },
    icon: { type: String }
  },
  data() {
    return {
      loading: false
    };
  },
};
</script>
